<template>
  <div>
    <StartYourJourneyForFreeV2
      v-if="newVersion"
      :stats="stats"
      :page="page"
    />
    <StartYourJourneyForFree
      v-else
      :instructors="instructors"
      :stats="stats"
      :page="page"
    />
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import StartYourJourneyForFree from '../components/StartYourJourneyForFree/StartYourJourneyForFree.vue';
import StartYourJourneyForFreeV2 from '../components/StartYourJourneyForFree/StartYourJourneyForFreeV2.vue';

export default {
  components: {
    StartYourJourneyForFree,
    StartYourJourneyForFreeV2,
  },
  mixins: [global],
  async asyncData({ $axios, $config, route }) {
    const pagesParams = [`ab-test=${Date.now()}`];
    pagesParams.push('courses=1');

    const [instructors, stats, page] = await Promise.all([
      $axios.$get('/team/instructors?instructorsPriority=true').catch(() => ({})),
      $axios.$get('/stats/courses?reduced=1').catch(() => ({})),
      $axios.$get(`/pages/${route.fullPath}?${pagesParams.join('&')}`).catch(() => ({})),
    ]);

    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    let newVersion = true;

    if (page.tests && page.tests['start-your-journey-for-free'] === 0) {
      newVersion = false;
    }

    return {
      instructors,
      stats,
      page,
      newVersion,
    };
  },
  head() {
    // const metaDescription = `Make the first step to a successful career in data science. Enjoy free access to ${this.stats.rounded.freeVideoDuration}+ h of video, ${this.stats.rounded.freeExercises}+ exercises, and expert support. Start today!`;

    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: { ...this.page } },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps({ ...this.page, metaImage: '365-Data-Science-Free-Plan-OG.jpg' }),
      script: [
        { src: 'https://players.brightcove.net/6258000438001/FHDad0Z7G_default/index.min.js', async: true },
        linkedData,
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
div {
  background-color: var(--main-dark);
}
</style>
